import { render, staticRenderFns } from "./q-remark.vue?vue&type=template&id=d8fa2550&scoped=true&"
import script from "./q-remark.vue?vue&type=script&lang=js&"
export * from "./q-remark.vue?vue&type=script&lang=js&"
import style0 from "./q-remark.vue?vue&type=style&index=0&id=d8fa2550&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa2550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhangenlong/vhall/saas-sdk-questionnaire/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8fa2550')) {
      api.createRecord('d8fa2550', component.options)
    } else {
      api.reload('d8fa2550', component.options)
    }
    module.hot.accept("./q-remark.vue?vue&type=template&id=d8fa2550&scoped=true&", function () {
      api.rerender('d8fa2550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/questionnaire/q-remark.vue"
export default component.exports